module.exports = __webpack_public_path__ + "img/psaltire-1748-pagina-de-titlu-big.1774dc2c.jpg";